export default __webpack_public_path__ + "8a21da9.png";